module.exports = __webpack_public_path__ + "img/0.d318adf7.jpg";